import { render, staticRenderFns } from "./PersonDetail.vue?vue&type=template&id=7b6506a7&"
import script from "./PersonDetail.vue?vue&type=script&lang=js&"
export * from "./PersonDetail.vue?vue&type=script&lang=js&"
import style0 from "./PersonDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports